/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}#company-person-name-text[_ngcontent-%COMP%]{font-size:1rem!important;font-weight:700;text-align:right}"];
export { styles as styles };
